import React from "react";

const svgProps = {
  className: "admin-rail-icon-svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true
};

function S({ children }) {
  return <svg {...svgProps}>{children}</svg>;
}

export function IconDashboard() {
  return (
    <S>
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="11" width="7" height="10" rx="1" />
      <rect x="3" y="15" width="7" height="6" rx="1" />
    </S>
  );
}

export function IconUsers() {
  return (
    <S>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </S>
  );
}

export function IconUserSingle() {
  return (
    <S>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1" />
    </S>
  );
}

export function IconBell() {
  return (
    <S>
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </S>
  );
}

export function IconSettings() {
  return (
    <S>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </S>
  );
}

export function IconTrophy() {
  return (
    <S>
      <path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4z" />
      <path d="M7 4H5a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h2M17 4h2a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-2" />
    </S>
  );
}

export function IconCalendar() {
  return (
    <S>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </S>
  );
}

export function IconCalendarPlus() {
  return (
    <S>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18M12 15v6M9 18h6" />
    </S>
  );
}

export function IconWallet() {
  return (
    <S>
      <path d="M19 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
      <path d="M3 10h14a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3" />
      <path d="M17 13h.01" />
    </S>
  );
}

export function IconBanknote() {
  return (
    <S>
      <rect x="2" y="6" width="20" height="12" rx="2" />
      <circle cx="12" cy="12" r="3" />
      <path d="M6 12h.01M18 12h.01" />
    </S>
  );
}

export function IconAward() {
  return (
    <S>
      <circle cx="12" cy="8" r="6" />
      <path d="M8.21 13.89L7 23l5-3 5 3-1.21-9.12" />
    </S>
  );
}

export function IconHeart() {
  return (
    <S>
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </S>
  );
}

export function IconHandCoins() {
  return (
    <S>
      <path d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L7 13" />
      <path d="M7 15l-1.5 4.5a2 2 0 0 0 1.9 2.5H19" />
      <path d="M14 8V5M17 8V5M20 8V5" />
      <circle cx="17" cy="3" r="1" />
      <circle cx="14" cy="3" r="1" />
      <circle cx="20" cy="3" r="1" />
    </S>
  );
}

export function IconUserPlus() {
  return (
    <S>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <line x1="19" y1="8" x2="19" y2="14" />
      <line x1="22" y1="11" x2="16" y2="11" />
    </S>
  );
}

export function IconPhone() {
  return (
    <S>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.86.3 1.7.54 2.5a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.58-1.11a2 2 0 0 1 2.11-.45c.8.24 1.64.42 2.5.54A2 2 0 0 1 22 16.92z" />
    </S>
  );
}

export function IconMessageSquare() {
  return (
    <S>
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </S>
  );
}

export function IconBuilding() {
  return (
    <S>
      <path d="M3 21h18M6 21V7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v14M14 21V11a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10" />
      <path d="M9 9h.01M9 13h.01M9 17h.01" />
    </S>
  );
}

export function IconBuilding2() {
  return (
    <S>
      <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18M6 12h12" />
      <path d="M6 16h12M10 6h4M10 10h4" />
    </S>
  );
}

export function IconClipboard() {
  return (
    <S>
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <rect x="8" y="2" width="8" height="4" rx="1" />
    </S>
  );
}

export function IconArrowLeftRight() {
  return (
    <S>
      <path d="M8 3L4 7l4 4M16 21l4-4-4-4M4 7h16M20 17H4" />
    </S>
  );
}

export function IconWrench() {
  return (
    <S>
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
    </S>
  );
}

export function IconTruck() {
  return (
    <S>
      <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2M15 18h2M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
      <circle cx="17" cy="18" r="2" />
      <circle cx="7" cy="18" r="2" />
    </S>
  );
}

export function IconBookOpen() {
  return (
    <S>
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2zM22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
    </S>
  );
}

export function IconBook() {
  return (
    <S>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </S>
  );
}

export function IconBooks() {
  return (
    <S>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      <path d="M9 10h6M9 14h4" />
    </S>
  );
}

export function IconBookPlus() {
  return (
    <S>
      <path d="M12 7v6M9 10h6" />
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </S>
  );
}

export function IconList() {
  return (
    <S>
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" />
      <line x1="3" y1="18" x2="3.01" y2="18" />
    </S>
  );
}

export function IconFileStack() {
  return (
    <S>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6M10 13h8M10 17h8M10 9h4" />
    </S>
  );
}

export function IconFileText() {
  return (
    <S>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
    </S>
  );
}

export function IconUpload() {
  return (
    <S>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" />
    </S>
  );
}

export function IconNewspaper() {
  return (
    <S>
      <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2" />
      <path d="M18 14h-8M15 18h-5M10 6h8v8h-8V6z" />
    </S>
  );
}

export function IconBarChart() {
  return (
    <S>
      <line x1="12" y1="20" x2="12" y2="10" />
      <line x1="18" y1="20" x2="18" y2="4" />
      <line x1="6" y1="20" x2="6" y2="16" />
    </S>
  );
}

export function IconPieChart() {
  return (
    <S>
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
      <path d="M22 12A10 10 0 0 0 12 2v10z" />
    </S>
  );
}

export function IconScale() {
  return (
    <S>
      <path d="M12 3v18M5 21h14M5 7l5-4 5 4M5 17l5 4 5-4" />
      <circle cx="7.5" cy="7" r="1.5" />
      <circle cx="16.5" cy="17" r="1.5" />
    </S>
  );
}

export function IconLock() {
  return (
    <S>
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </S>
  );
}

export function IconBed() {
  return (
    <S>
      <path d="M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
      <path d="M2 18h20" />
    </S>
  );
}

export function IconDoorOpen() {
  return (
    <S>
      <path d="M13 4h3a2 2 0 0 1 2 2v14M13 4H9a2 2 0 0 0-2 2v14M13 4v16" />
      <path d="M9 21h6" />
    </S>
  );
}

export function IconBadgeCheck() {
  return (
    <S>
      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.75z" />
      <path d="M9 12l2 2 4-4" />
    </S>
  );
}

export function IconLogIn() {
  return (
    <S>
      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3" />
    </S>
  );
}

export function IconLogOutNav() {
  return (
    <S>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
    </S>
  );
}

export function IconPackage() {
  return (
    <S>
      <path d="M16.5 9.4 7.55 4.24M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12" />
    </S>
  );
}

export function IconDownload() {
  return (
    <S>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
    </S>
  );
}

export function IconSparkles() {
  return (
    <S>
      <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
    </S>
  );
}

export function IconDroplets() {
  return (
    <S>
      <path d="M7 16.3c1.3 1 3.1 1.7 5 1.7s3.7-.7 5-1.7M12 3v10" />
      <path d="M5.5 12.5c1.5-2 3.5-5.5 3.5-5.5s2 3.5 3.5 5.5a5 5 0 1 1-7 0z" />
    </S>
  );
}

export function IconMapPin() {
  return (
    <S>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </S>
  );
}

export function IconGraduationCap() {
  return (
    <S>
      <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
      <path d="M6 12v5c3 3 9 3 12 0v-5" />
    </S>
  );
}

export function IconCreditCard() {
  return (
    <S>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M2 10h20" />
    </S>
  );
}

export function IconTags() {
  return (
    <S>
      <path d="M12 2H2v10l9.29 9.29a1 1 0 0 0 1.41 0l6.59-6.59a1 1 0 0 0 0-1.41L12 2zM7 7h.01" />
    </S>
  );
}

export function IconFolderTree() {
  return (
    <S>
      <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />
    </S>
  );
}

const DEFAULT = IconDashboard;

/** Maps every nav `iconKey` from *PageLayout.jsx files to an icon component. */
const NAV_ICON_MAP = {
  dashboard: IconDashboard,
  settings: IconSettings,
  users: IconUsers,
  notifications: IconBell,
  "event-management": IconTrophy,
  "office-records-group": IconBuilding,

  "participants-list": IconUsers,
  memberships: IconCreditCard,
  tournaments: IconTrophy,
  "tournament-registration": IconCalendarPlus,
  "tournament-results": IconTrophy,
  "finance-payments": IconWallet,
  "offline-payments": IconFileText,
  certificates: IconAward,
  "certificates-track": IconAward,

  visitors: IconUserPlus,
  properties: IconBuilding,
  "employee-attendance": IconClipboard,
  "inward-outward-register": IconArrowLeftRight,
  "maintenance-records-control": IconWrench,
  "maintenance-records": IconWrench,
  "phone-calls": IconPhone,
  "phone-call-logs-control": IconPhone,
  "complaints-feedback": IconMessageSquare,
  "tos-fros-control": IconTruck,
  "tos-fros": IconTruck,
  "meetings-appointments": IconCalendar,
  ledgers: IconBookOpen,
  "cash-book": IconBanknote,
  "cheque-issues": IconFileText,
  "cheque-collection": IconBanknote,
  "cheque-masters": IconList,

  "hostel-records": IconBuilding2,
  "hostel-property-control": IconBuilding,
  "hostel-room-control": IconBed,
  "hostel-bookings-control": IconCalendar,
  "hostel-guest-control": IconUsers,
  "hostel-id-verification": IconBadgeCheck,
  "hostel-payments-control": IconWallet,

  "donor-control": IconHeart,
  "donors-list": IconUsers,
  "donor-certificates-control": IconAward,
  "donations-control": IconHandCoins,
  "donor-equipment-list": IconPackage,
  "donor-tournament-support": IconTrophy,
  "donor-student-support": IconGraduationCap,
  "donor-payments-control": IconWallet,

  students: IconGraduationCap,
  "collect-donations": IconHandCoins,
  "add-donor": IconUserPlus,
  "donation-tracking": IconBarChart,
  "donation-history": IconBookOpen,
  "download-receipts": IconDownload,
  "80g-certificates": IconAward,

  "running-memberships-tournaments": IconTrophy,
  "my-memberships": IconCreditCard,
  "my-tournaments": IconTrophy,
  "my-certificates": IconAward,
  "my-payments": IconWallet,
  "books-categories": IconTags,
  "digit-books": IconBook,
  articles: IconNewspaper,
  "my-books": IconBooks,

  "visitor-records": IconDoorOpen,
  "visitor-registration": IconUserPlus,
  "phone-call-logs": IconPhone,
  "appointments-register": IconCalendar,
  "inwards-register": IconArrowLeftRight,
  "outwards-register": IconArrowLeftRight,
  "maintanence-status": IconWrench,

  books: IconBooks,
  "add-book": IconBookPlus,
  "manage-book": IconFileStack,
  "book-categories": IconFolderTree,
  "digital-library": IconSparkles,
  "upload-pdfs": IconUpload,
  "manage-articles": IconNewspaper,
  "book-circulation": IconArrowLeftRight,
  "issue-book": IconLogIn,
  "return-book": IconLogOutNav,
  "issued-books": IconList,
  members: IconUsers,
  "member-list": IconUsers,
  "library-access-control": IconLock,
  "attendance-records": IconClipboard,
  "fine-management": IconScale,
  reports: IconBarChart,
  "book-issue-report": IconBarChart,
  "fine-report": IconScale,
  "usage-report": IconPieChart,

  "books-list": IconBooks,
  "book-issues": IconLogIn,
  "book-returns": IconLogOutNav,
  "library-attendance": IconClipboard,
  "digital-content": IconSparkles,

  "hostel-bookings": IconCalendar,
  "new-booking": IconCalendarPlus,
  "bookings-list": IconList,
  "hostel-guests": IconUsers,
  "guest-registration": IconUserPlus,
  "id-verification": IconBadgeCheck,
  "check-in-out": IconLogIn,
  "check-in": IconLogIn,
  payments: IconWallet,
  "room-availability": IconMapPin,
  "hostel-payments": IconWallet,

  "room-status": IconBed,
  "cleaning-tasks": IconDroplets,
  "assigned-rooms": IconMapPin,
  "maintenance-tasks": IconWrench,
  "cleaning-history": IconClipboard,

  bookings: IconCalendar,
  guests: IconUserSingle,

  "apply-membership": IconCreditCard,

  "ledger-records": IconBookOpen,
  "cash-book-records": IconBanknote,
  "membership-payments": IconCreditCard,
  "tournament-payments": IconTrophy,
  donations: IconHeart,
  "payment-reports": IconBarChart,
  "finance-reports": IconPieChart
};

export function NavRailIcon({ iconKey }) {
  const Icon = NAV_ICON_MAP[iconKey] || DEFAULT;
  return <Icon />;
}
